// extracted by mini-css-extract-plugin
module.exports = {"bg_footer":"Footer_bg_footer__bDBVG","border":"Footer_border__Xbly_","borderAr":"Footer_borderAr__W6jOD","border_top":"Footer_border_top__tUren"};